export default {
  en: {
    email_verification: "Email Verification",
    send_verification_email: "Send Verification Email",
    email_verification_sent: "Email Verification Sent",
    please_check_your_email: "Please check your email for a verification link.",
    once_verified_you_will_be_redirected:
      "Once verified, you will be redirected to the app.",
    email_verification_success: "Your email has been verified successfully.",
    redirecting_to_app_in: "Redirecting to app in",
    unknown_error: "An unknown error occurred while verifying your email.",
  },
  de: {
    email_verification: "E-Mail-Verifizierung",
    send_verification_email: "Verifizierungs-E-Mail senden",
    email_verification_sent: "E-Mail-Verifizierung gesendet",
    please_check_your_email:
      "Bitte überprüfen Sie Ihre E-Mail auf einen Verifizierungslink.",
    once_verified_you_will_be_redirected:
      "Nach erfolgreicher Verifizierung werden Sie zur App weitergeleitet.",
    email_verification_success: "Ihre E-Mail wurde erfolgreich verifiziert.",
    redirecting_to_app_in: "Weiterleitung zur App in",
    unknown_error:
      "Beim Verifizieren Ihrer E-Mail ist ein unbekannter Fehler aufgetreten.",
  },
};
